import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=67958f4a"
import script from "./sidebar-item.vue?vue&type=script&lang=js"
export * from "./sidebar-item.vue?vue&type=script&lang=js"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=67958f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports